module.exports = __webpack_public_path__ + "static/media/upload_modal_corner.0c159ebd.svg";